export enum APPLICATION_ACTIONS {
	APPLICATION_APPROVE = 'APAPP',
	APPLICATION_DENY = 'APDEN',
	APPLICATION_INCOMPLETE = 'APINC',
	PAYMENT_INCOMPLETE = 'APPIC',
	PAYMENT_REVIEW = 'APPPR',
	APPLICATION_CANCEL = 'APCAN',
	APPLICATION_CLOSE = 'APCLO',
	APPLICATION_SUBMITTED_PENDING_REVIEW = 'APSPR',
	APPLICATION_VOID = 'APVOI',
	APPLICATION_REOPEN_PAYMENT_STATUS = 'APRPS',
	APPLICATION_REPAYMENT_REQUIRED = 'APRR',
	APPLICATION_PAYMENT_COMPLETE = 'APPC',
	APPLICATION_SEND_TO_COLLECTIONS = 'APSTC',
	APPLICATION_EDIT_EDUCATION_PROVIDER = 'APEDP',
	APPLICATION_BENEFIT_PERIOD = 'APBP',
	APPLICATION_EDIT_BENEFIT_PERIOD = 'APEBP',
	APPLICATION_EDIT_PROGRAMS_DEGREES = 'APEPD',
	APPLICATION_EDIT_PROGRAMS_FOS = 'APEPF',
	APPLICATION_EDIT_COURSES = 'APEC',
	APPLICATION_EDIT_BYPASS_REVIEWER = 'APEBY',
	APPLICATION_EDIT_BYPASS_REVIEWER_ADVANCED = 'APBYA',
	RESOLVE_DENY_RULES = 'RUDEN',
	RESOLVE_MANUAL_RULES = 'RUMAN',
	RESOLVE_INCOMPLETE_RULES = 'RUINC',
	RESOLVE_CARRYOVER_RULES = 'RUCAR',
	APPLICATION_EDIT_SESSION_DATES = 'APSED',
	APPLICATION_UPLOAD_DOCUMENTS = 'APDUP',
	APPLICATION_EDIT_APPROVED_AMOUNTS = 'APEAA',
	APPLICATION_EDIT_PAYMENT_AMOUNTS = 'APEPA',
	APPLICATION_EDIT_PERCENT_PAYOUT = 'APEPP',
	APPLICATION_VERIFY_GRADES = 'APVG',
	APPLICATION_EDIT_GRADES = 'APEG',
	APPLICATION_ADD_EXPENSE = 'APAE',
	DOCUMENT_VIEW_ORPHANED = 'DCVOD',
	GENERATE_VERIFICATION_LETTER = 'AOGVL',
	ADD_PARTICIPANT_ALERT = 'PAAPA',
	ADD_PARTICIPANT_EXCEPTION = 'PAPEX',
	EDIT_PARTICIPANT_ALERTS = 'PAEPA',
	EDIT_PARTICIPANT_NAME = 'PAREN',
	EDIT_PARTICIPANT_IDS = 'PAREI',
	EDIT_LIMITED_ALERT = 'PAELA',
	PARTICIPANT_EDIT_GENERIC_FIELDS = 'PAEGF',
	MARK_AS_ESCHEATED = 'AOESF',
	VIEW_DOCUMENT_CONFIDENCE = 'DCVDC',
	APPLICATION_ADD_SAVINGS = 'APEAS',
	APPLICATION_REOPEN_TO_PREVIOUS_STATUS = 'APRPS',
	APPLICATION_READY_FOR_PAYMENT = 'APRFP',
	APPLICATION_EDIT_REPAYMENTAMOUNT_OWED = 'APERP',
	OPEN_FOR_DOCUMENTS = 'APPC',
	APPLICATION_ADD_COURSE = 'APEAC',
	ADD_BOOK_EXPENSE_APP = 'APOAB',
	ADD_RELATED_APP = 'APOAR',
	SUBMIT_APPLICATION = 'APESA',
	ADD_COURSE_WITH_TAX_QUESTIONS = 'APETQ',
	VIEW_VIRTUAL_CARD_AMOUNTS = 'APVCA',
	SUBMIT_FAST_TRACK_PAYMENT = 'FTPAY',
	APPLICATION_LIMITED_EDIT_SESSION_DATES = 'APLSD',
	ADD_PAYMENT_REQUEST = 'APOAP',
	ADD_REFUND = 'APARD',
	EDIT_REPAYMENT_SET_UP = 'PAERS',
	EDIT_PARTICIPANT_ADDRESS = 'PAEAD',
	APPROVE_APPEAL = 'ALAPP',
	STOP_PAYMENT = 'APESP',
	EDIT_APPEAL_REVIEWER = 'APEAR',
	EDIT_REVIEWER = 'PARER'
}